<template>
  <v-footer class="footer">
    <v-container class="cgu">
      <div class="title">
        <svg-element
          :size="20"
          icon="info"
        />
        <h4 class="nds-text-h4">
          {{ $t('footer_title') }}
        </h4>
      </div>
      <p class="nds-text-p description">
        {{ $t('footer_description') }}
      </p>
    </v-container>
  </v-footer>
</template>

<script>
import SvgElement from '@/components/elements/SvgElement.vue';
export default {
  name: 'LoginFooterElement',
  components: {
    SvgElement,
  },
};
</script>

<style lang="scss" scoped>
@import '@/constants/variables.module.scss';

.footer {
  width: 100%;
  margin : 0;
  padding: 5px 64px;
  background-color: $whisper;

  .cgu {
    padding: 0;

    .title {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin: 16px 0;
      gap: 8px;
      svg{
        --color: #{$cornflower-blue};
      }
    }

    .description {
      text-align: justify;
      margin: 0 0 16px 0 !important;
    }
  }

}
</style>

<i18n src="@/locales/common.json"></i18n>

<i18n src="@/locales/components/elements/logins/login-footer-element.json"></i18n>
